export default __webpack_public_path__ + "static/media/menu-icon.ab8ccff0.webp";